import * as React from 'react'
import Service from './channelService'

export const TapChannelServiceContext = React.createContext(null as any as Service)
